export function getSubdomain(hostname = typeof window !== "undefined" ? window.location.hostname : "") {
  if (!hostname) return null;
  const lower = hostname.toLowerCase().split(":")[0];
  if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(lower)) return null;

  if (lower.endsWith(".localhost")) {
    const sub = lower.slice(0, -".localhost".length);
    return sub && sub !== "www" ? sub : null;
  }

  const parts = lower.split(".");
  if (parts.length >= 3) {
    const sub = parts[0];
    const reserved = new Set(["www", "join", "app", "api", "admin", "mail", "staging", "venproapp", "dev"]);
    if (reserved.has(sub)) return null;
    return sub;
  }
  return null;
}

export function getPublicCatalogueUrl(slug = "nwautosupreme") {
  if (typeof window === "undefined") return `https://${slug}.venpro.app`;
  const hostname = window.location.hostname.toLowerCase();
  if (hostname.includes("localhost") || /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) {
    return `${window.location.origin}/c/${slug}`;
  }
  return `https://${slug}.venpro.app`;
}

export function getPublicInvoiceUrl(invoiceId, slug = "nwautosupreme") {
  if (typeof window === "undefined") return `https://${slug}.venpro.app/invoice/${invoiceId}`;
  const hostname = window.location.hostname.toLowerCase();
  if (hostname.includes("localhost") || /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) {
    return `${window.location.origin}/pay/${invoiceId}`;
  }
  return `https://${slug}.venpro.app/invoice/${invoiceId}`;
}
